import React from "react";
import { BsTelephoneFill } from "react-icons/bs";

export const PhoneNumber = () => {
  return (
    <section>
      <a href="tel:+773-797-2118">
        <span className="pe-2">
          <BsTelephoneFill style={{ color: "#000000" }} />
        </span>
        +773-797-2118
      </a>
    </section>
  );
};
